import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  mobilePrefix: PropTypes.string,
  mobile: PropTypes.string,
  className: PropTypes.string,
};

const Phone = ({ mobilePrefix, mobile, className }) => {
  const prefix = mobilePrefix === 'other' ? '' : mobilePrefix;
  return mobile ?
    <a className={className} href={`tel:+${prefix}${mobile}`}>+{prefix}{mobile}</a> :
    null;
};

Phone.propTypes = propTypes;

export default Phone;



// WEBPACK FOOTER //
// ./src/components/Phone.jsx